export default __webpack_public_path__ + "static/media/eyes.5c743a2a.png";